export enum FileType {
  Nested,
  Unnested,
}

export interface FileUpload {
  file: File | null;
  fileType: FileType | null;
  area?: "excel" | "intelligent" | null;
}
